// Genera el bloque `:root { ... }` con las CSS vars de marca para inyectarlo en runtime (rcp-10).
// Puerto LOCAL de scripts/appliers/portal-css-generator.mjs:buildPortalBrandCss (webpack no compila
// el .mjs cross-package). Emite las MISMAS vars que el applier horneaba en colors.css, así que
// inyectar este <style> en runtime no cambia el contrato CSS. Fuente canónica del contrato de nombres
// de var: scripts/appliers/portal-css-generator.mjs.

const HEX_PATTERN = /^#[0-9A-Fa-f]{6}$/;

const hexToRgb = (hex) => {
	const m = /^#([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})$/.exec(hex);
	return m ? `${parseInt(m[1], 16)}, ${parseInt(m[2], 16)}, ${parseInt(m[3], 16)}` : "";
};

const PALETTE = { primary: "--brand-primary", secondary: "--brand-secondary", accent: "--brand-accent", themeColor: "--brand-theme-color" };
const PALETTE_RGB = { primary: "--brand-primary-rgb", secondary: "--brand-secondary-rgb", accent: "--brand-accent-rgb" };
const QUASAR = { primary: "--q-primary", secondary: "--q-secondary", accent: "--q-accent" };
const ZONES = {
	timeRegister: "--color-time-register",
	employeeArea: "--color-employee-area",
	payrolls: "--color-payrolls",
	documents: "--color-documents",
	profile: "--color-profile",
	corporate: "--color-corporate",
	publication: "--color-publication",
	departments: "--color-departments",
	news: "--color-news",
	contact: "--color-contact",
	holidays: "--color-holidays",
	absences: "--color-absences",
	suggestions: "--color-suggestions",
};

export const buildTenantColorsCss = (colors = {}) => {
	const decls = [];
	const pushHex = (map, source) => {
		for (const [key, varName] of Object.entries(map)) {
			const value = source?.[key];
			if (!value || !HEX_PATTERN.test(value)) continue;
			decls.push(`  ${varName}: ${value};`);
		}
	};
	const pushRgb = (map, source) => {
		for (const [key, varName] of Object.entries(map)) {
			const value = source?.[key];
			if (!value || !HEX_PATTERN.test(value)) continue;
			decls.push(`  ${varName}: ${hexToRgb(value)};`);
		}
	};

	pushHex(PALETTE, colors);
	pushRgb(PALETTE_RGB, colors);
	pushHex(ZONES, colors.zones ?? {});
	pushHex(QUASAR, colors);
	for (const [key, varName] of Object.entries(QUASAR)) {
		const value = colors?.[key];
		if (value && HEX_PATTERN.test(value)) decls.push(`  ${varName}-rgb: ${hexToRgb(value)};`);
	}

	return decls.length ? `:root {\n${decls.join("\n")}\n}` : ":root { }";
};
